var _radialGradient, _linearGradient, _radialGradient2, _radialGradient3, _radialGradient4, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIberdrolaSmartMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(14.7981 0 0 14.7932 6.33213 1.69642)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483377,
    stopColor: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88542,
    stopColor: "#3870c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3870c0"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 5.65066,
    x2: 10.7892,
    y1: 5.77575,
    y2: 13.6634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdd41f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033705,
    stopColor: "#bdd41f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14739,
    stopColor: "#bdd41f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#518e32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518e32"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(14.7391 0 0 14.758 2.61568 1.68708)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2dd2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19099,
    stopColor: "#c2dd2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628993,
    stopColor: "#518e32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76999,
    stopColor: "#518e32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518e32"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(14.8166 0 0 14.7136 6.3545 1.75088)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122987,
    stopColor: "#b3caea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38201,
    stopColor: "#b3caea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742564,
    stopColor: "#3870c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3870c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3870c0"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(14.798 0 0 14.7931 10.185 1.68306)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13541,
    stopColor: "#f2f021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286736,
    stopColor: "#fbc419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbc419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888148,
    stopColor: "#f46b18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94998,
    stopColor: "#f46b18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46b18"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#43b17e",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#fef5eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.87528 10.7266c-.00941.5427.21944 1.3.83285 1.9119 2.09217 2.0923 7.82547.8702 4.35927-9.2635-.3075 3.9016-5.12582 3.63603-5.19212 7.3516z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.1253 10.7274c-.00984.5427.21986 1.3001.83323 1.912.20317.204.44099.3743.70105.5098-.16211.8297-.22327 1.7795-.1095 2.882l.586-.0312c-.21472-1.0165-.23525-1.9073-.13174-2.6972 2.45819.9186 6.29836-1.1975 3.31366-9.9278-.3084 3.902-5.1264 3.6364-5.1927 7.3524z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.1253 10.7091c-.0098.5414.21899 1.2969.82996 1.9074.20237.2035.43926.3733.6983.5085.1308-.6723.32764-1.264.55302-1.7913-.39538-.6258-.80737-1.84294-.78522-2.68889l.00043-.00042c.16914.72566.55728 1.69661.93562 2.35441.29909-.6284.65356-1.1885 1.0123-1.73327-.40091-.60322-.50359-1.59549-.4972-1.79002 0-.00299.00426-.00298.00681-.00469.10524.34427.30463.93382.67147 1.5204.33956-.51363.67274-1.01789.95181-1.56052-.18023-.36944-.2991-.94876-.28674-1.13689h.00085c.07584.25596.28418.58914.4512.79647.36939-.7312.55515-1.33656.63652-1.72477.09075-.60066.0997-1.2559-.00681-1.99051-.30719 3.89232-5.10628 3.62738-5.17232 7.3341z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.87528 10.7337c-.00944.5406.22007 1.2951.83525 1.9047.07335.0729.151.141.23208.2054 1.06219-.8589 1.76529-2.6217 1.33549-5.62505-1.2158.85585-2.37065 1.71851-2.40282 3.51495z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7191 10.7266c-.0099.5427.2198 1.3.8324 1.9119 2.0922 2.0923 7.8259.8702 4.3597-9.2635-.3088 3.9016-5.1263 3.63603-5.1921 7.3516z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m25.125 30.8438h-.9375v1.875h-1.0313c-.2588 0-.4687.2098-.4687.4687v2.8594c0 1.6951 1.2674 3.0943 2.9063 3.3016v3.1203h.9374v-3.106c1.6287-.1424 2.9063-1.5097 2.9063-3.1753v-3c0-.2589-.2099-.4687-.4687-.4687h-1.0313v-1.875h-.9375v1.875h-1.875zm-1.5 5.2031v-2.3907h4.875v2.5313c0 1.2426-1.0074 2.25-2.25 2.25h-.2344c-1.3203 0-2.3906-1.0703-2.3906-2.3906z",
    fill: "#449fd9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.4062 28.4062h-1.4062v14.4376c0 .4142.3358.75.75.75h20.625c.4142 0 .75-.3358.75-.75v-14.4376h-1.3125v13.875h-19.4063z",
    fill: "#2aab6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.75 18.75c-.4142 0-.75.3358-.75.75v6.1875h1.4062v-5.5313h4.7813v-1.4062z",
    fill: "#2aab6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.4189 18.7295.734-1.0881 10.0262 6.7627-.734 1.0881z",
    fill: "#f39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.1864 28.9713.7339-1.0881-14.4158-9.7223c-.2534-.1709-.5852-.1709-.8387 0l-14.4158 9.7223.7339 1.0881 14.1013-9.5114z",
    fill: "#2aab6d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIberdrolaSmartMonitor);
export default __webpack_public_path__ + "static/media/IberdrolaSmartMonitor.813041549ac456fd1e4ada836dae22e4.svg";
export { ForwardRef as ReactComponent };